var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tree"},_vm._l((_vm.data),function(node,index){return _c('tree-node',{key:index,attrs:{"node":node,"mode":_vm.mode}})}))}
var staticRenderFns = []

export { render, staticRenderFns }